import { memo, useEffect, useRef } from 'react';

interface Props
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  src: string;
}

export const ImgSVG = memo(({ src, ...rest }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const elmRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    fetch(src)
      .then((res) => res.text())
      .then((data) => {
        if (ref.current) {
          const parser = new DOMParser();
          const svgDoc = parser.parseFromString(data, 'image/svg+xml');
          const elm = svgDoc.documentElement;
          const rect = ref.current.getBoundingClientRect();
          elm.setAttribute('width', `${rect.width}`);
          elm.setAttribute('height', `${rect.height}`);
          ref.current.innerHTML = elm.outerHTML;
          elmRef.current = elm;
        }
      });
  }, [src]);

  return <div ref={ref} {...rest} />;
});
